import React, {useEffect, useState} from "react";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import FramerFade from "../../../components/Animation/Fade";
import {Button, FormControl, FormHelperText, InputAdornment} from "@mui/material";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    AuthActionType, authLogin,
    changePassword, get_auth_info, get_routes, getCommoditySizeList,
    getEmailCodeForForgetPW,
    getEmailCodeVerify, Logout,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import {noop} from "lodash";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import LocalStorage from "../../../utils/LocalStorage";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {findRoutes, keyToNodeMap} from "../../../utils/globalFunction";
import {useTranslation} from "react-i18next";
const UserPasswordChange = ({setOpen}) => {
    const {t, i18n} = useTranslation();
    const schema = yup
        .object({
            password: yup.string().min(
                6,
                t('ForgotPasswordPage.Password must contain 6 or more characters')
            ).matches(/^\S*$/, t('ForgotPasswordPage.No spaces allowed in password')).minLowercase(1, t('ForgotPasswordPage.Password must contain at least 1 lower case letter'))
                .minUppercase(1, t('ForgotPasswordPage.Password must contain at least 1 upper case letter'))
                .minNumbers(1, t('ForgotPasswordPage.Password must contain at least 1 number'))
                .required(t("Required")),
            confirmPassword: yup
                .string()
                .oneOf([yup.ref("password"), null], t('ForgotPasswordPage.Passwords must match'))
                .required(t("Required")),
        })

    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const userInfo = useSelector(state => state?.auth?.userSetting,(prev, next) => prev === next);
    const originalEmail = userInfo?.email
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [activeStep, setActiveStep] = useState(0);
    const [code, setCode] = useState(Array(6).fill(''));
    const [seconds, setSeconds] = useState(0);
    const [show, setShow] = useState(true);


    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);


    const handleClickShowCurrentPassword = () => setShowCurrentPassword((show) => !show);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowPasswordConfirmation = () => setShowPasswordConfirmation((show) => !show);


    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);
    useEffect(() => {
        if(activeStep === 0){
            // reset()
            clearErrors()
        }

        if(activeStep === 1){
            setCode(Array(6).fill(''));

            setSeconds(99); // 重置秒数
        } else {

            setSeconds(0);

        }

        // if(activeStep === 5) {
        //     const apiGet = async () => {
        //         await dispatch(getVerificationCode(noop,onError))
        //     }
        //     apiGet().then()
        // }



    }, [activeStep])
    
    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };
    
    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);
        
        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        } else if (e.key === "Enter") {
            submitCode();
        }
    };
    


    const handlePasswordCheck = async () => {
        if (!!originalEmail) {
            await dispatch(getEmailCodeForForgetPW(originalEmail,onConfirmChangeSuccess,onError))
        }else {
            dispatch(onErrorAlert(t("AccountPage.There is no email linked to this account, please link first.")))
        }
    }


    const onConfirmChangeSuccess = () => {
        setActiveStep(1)
    }

    const handleResendVerifyOriginalEmail = async () => {
        if (!!originalEmail) {
            await dispatch(getEmailCodeForForgetPW(originalEmail,onEmailResendSuccess,onError))
            // onEmailResendSuccess()
        }
    }


    const onEmailResendSuccess =() => {
        dispatch(onSuccessAlert(t('resend verification code successfully')))
        setSeconds(99);
    }


    const handleVerifyOriginalEmailCode = async () => {
        submitCode();
    }
    
    const submitCode = async () => {
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!==''){
            formData.emailAddress = originalEmail
            formData.emailCode = verificationCode
            await dispatch(getEmailCodeVerify(formData,onOriginalEmailVerifySuccess,onError))
        }
    };


    async function onOriginalEmailVerifySuccess() {
        setActiveStep(2)
    }

    const onAuthSuccess = async (x,y) => {

        const keys = JSON.parse(LocalStorage.getItem('keys'))
        if(keys && keys.length > 0){
            const result = findRoutes(keys, keyToNodeMap)
            nav(`/app${result}`)
            dispatch(onSuccessAlert('Log in Successfully'))
        } else {
            dispatch(onErrorAlert(' You do not have any permissions assigned. Please contact the administrator.'))

            setIsLoading(false)
        }


    }

    const onLoginSuccess = async (msg) => {
        dispatch({
            type: AuthActionType.CHANGE_LOADING,
            payload: true
        })

        await dispatch(get_auth_info(async () => {
            await dispatch(get_routes(onAuthSuccess,onError))
        }, onError))

        LocalStorage.setItem('username', getValues("username"))

    }

    const onLogOutSuccess = (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        nav('/authentication/sign-in')
    }

    const onSuccess = (msg) =>{
        setOpen(false)
        dispatch(onSuccessAlert(t(msg)))
        let formData = {}
        formData.username = LocalStorage.getItem('sub_username')
        formData.password = getValues('password')


        const axiosPost = async () => {
            dispatch(Logout(onLogOutSuccess))
            // await  dispatch(authLogin(formData,onLoginSuccess,onError))
        }
        axiosPost().then()

        // nav('/authentication/sign-in')
    }

    const onError = async (msg) => {
        dispatch(onErrorAlert(msg))
    }


    const {
        register,
        trigger,
        reset,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const onSubmit = async (data) => {

        let error = false
        if(getValues('password').trim() !== getValues('confirmPassword').trim()){
            setError('confirmPassword',{message:t('ForgotPasswordPage.Passwords must match')})
            error = true
        }
        if(errors.password || errors.confirmPassword){
            error = true
        }

        trigger(['password','confirmPassword']).then(async r => {
            if (r && !error) {
                let formData = {}
                // formData.oldPassword = getValues('currentPassword')
                formData.newPassword = getValues('password')
                formData.confirmPassword = getValues('confirmPassword')
                formData.userName = localStorage.getItem('sub_username')
                await dispatch(changePassword(formData, onSuccess, onError))
            }
        })
    }

    return(
        <React.Fragment>
            {/*<CoverLayout image={bgImage}>*/}
            <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="success"
                mx={2}
                mt={-3}
                p={3}
                mb={1}
                textAlign="center"
            >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    {t('AccountPage.Change Password')}
                </MDTypography>
                <MDTypography display="block" variant="button" color="white" my={1}>
                    {t('AccountPage.Improve your security with a strong password.')}
                </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={2} px={3}>
                <MDBox>
                    <div style={{overflow: "hidden"}}>
                        <FramerFade isActive={activeStep === 0} delay={0}>
                            <MDBox mb={5} textAlign="center" >
                                <MDTypography variant="h5" fontWeight="medium"  mt={1}>
                                    {t('AccountPage.Are you sure you want to change your password?')}
                                </MDTypography>
                            </MDBox>
                            <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                <MDButton variant="outlined" color="info" onClick={() => {
                                    setOpen(false)
                                }}>
                                    {t('Cancel')}
                                </MDButton>
                                <MDButton variant="gradient" color="info" onClick={handlePasswordCheck}>
                                    {t('Continue')}
                                </MDButton>
                            </MDBox>
                        </FramerFade>

                    </div>
                    <div style={{overflow: "hidden"}}>
                        <FramerFade isActive={activeStep === 1} delay={0}>
                            <Grid textAlign='center'><Icon style={darkMode ? {color: 'white'} : {color: 'text'}}
                                                           fontSize={'large'}>lock</Icon></Grid>
                            <Typography variant={'h5'} align="center">
                                {t('ForgotPasswordPage.Enter your verification Code')}
                            </Typography>
                            <MDTypography align="center" display="block" variant="button" my={1}>
                                {`${t('AccountPage.As an additional security measure, kindly enter the six-digit code that has been sent to your email')} ${originalEmail}`}
                            </MDTypography>
                            <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                    {code.map((digit, index) => (
                                        <TextField
                                            key={index}
                                            id={`code-${index}`}
                                            value={digit}
                                            onChange={(e) => handleChange(e, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            InputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                                            autoFocus={index === 0}
                                            sx={{
                                                width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                        '-webkit-appearance': 'none',
                                                    }
                                                }
                                            }}
                                        />
                                    ))}
                                </MDBox>
                            </MDBox>
                            <MDBox mt={4} display="flex" alignItems="center" justifyContent="start">
                                <MDTypography display="block" variant="button">
                                    {t(`ForgotPasswordPage.Haven't receive a code?`)}
                                </MDTypography>
                                <Button sx={{padding: 1}} onClick={handleResendVerifyOriginalEmail}
                                        disabled={show}>{t('Resend')}</Button>
                                <MDTypography display="block" variant="button">
                                    {show && `${seconds}s`}
                                </MDTypography>
                            </MDBox>

                            <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                <MDButton variant="outlined" color="info"
                                          onClick={() => {
                                              setOpen(false)
                                          }}
                                >
                                    {t('Cancel')}
                                </MDButton>
                                <MDButton variant="gradient" color="info" onClick={handleVerifyOriginalEmailCode}>
                                    {t('Verify')}
                                </MDButton>
                            </MDBox>

                        </FramerFade>

                    </div>
                    <div style={{overflow: "hidden"}}>
                        <FramerFade isActive={activeStep === 2} delay={0}>
                            <MDTypography align="center" variant="h5" fontWeight="medium"  my={1}>
                                {t(`AccountPage.Original email verified successfully, please enter your new password.`)}
                            </MDTypography>
                             <div style={{position: 'relative'}}>
                                 <MDBox
                                     sx={{display: 'flex',justifyContent: 'center', alignItems: 'center'}}
                                 >
                                 </MDBox>
                                 <MDBox pt={4} pb={2} px={3}>
                                     <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                                         {/*<MDBox mb={1}>*/}
                                         {/*    <FormControl*/}
                                         {/*        // error={!!errors.password}*/}
                                         {/*        fullWidth*/}
                                         {/*        required*/}
                                         {/*        focused={true}*/}
                                         {/*    >*/}
                                         {/*        <MDInput*/}
                                         {/*            type={showCurrentPassword ? 'text' : 'password'}*/}
                                         {/*            label="Current Password"*/}
                                         {/*            variant="standard"*/}
                                         {/*            fullWidth*/}
                                         {/*            required*/}
                                         {/*            {...register("currentPassword")}*/}
                                         {/*            InputProps={{*/}
                                         {/*                endAdornment:*/}
                                         {/*                    <InputAdornment position="end">*/}
                                         {/*                        <IconButton*/}
                                         {/*                            aria-label="toggle password visibility"*/}
                                         {/*                            onClick={handleClickShowCurrentPassword}*/}
                                         {/*                            edge="end"*/}
                                         {/*                        >*/}
                                         {/*                            {showCurrentPassword ?*/}
                                         {/*                                <VisibilityOff color={darkMode ? 'white' : 'info.main'}/> :*/}
                                         {/*                                <Visibility color={darkMode ? 'white' : 'info.main'}/>}*/}
                                         {/*                        </IconButton>*/}
                                         {/*                    </InputAdornment>*/}

                                         {/*            }}*/}
                                         {/*        />*/}
                                         {/*    </FormControl>*/}
                                         {/*</MDBox>*/}
                                         <MDBox mb={1}>
                                             <FormControl
                                                 error={!!errors.password}
                                                 fullWidth
                                                 required
                                                 focused={true}
                                             >
                                                 <MDInput
                                                     type={showPassword ? 'text' : 'password'}
                                                     label={t("SignInPage.Password")}
                                                     variant="standard"
                                                     fullWidth
                                                     required
                                                     {...register("password")}
                                                     InputProps={{
                                                         endAdornment:
                                                             <InputAdornment position="end">
                                                                 <IconButton
                                                                     aria-label="toggle password visibility"
                                                                     onClick={handleClickShowPassword}
                                                                     edge="end"
                                                                 >
                                                                     {showPassword ?
                                                                         <VisibilityOff color={darkMode ? 'white' : 'info.main'}/> :
                                                                         <Visibility color={darkMode ? 'white' : 'info.main'}/>}
                                                                 </IconButton>
                                                             </InputAdornment>

                                                     }}
                                                 />
                                                 <FormHelperText sx={{fontWeight: 'medium'}}>{errors?.password?.message}</FormHelperText>
                                                 <MDTypography variant={'caption'} mt={1} >{t('ForgotPasswordPage.At least 6 characters')}</MDTypography>
                                                 <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one uppercase')}</MDTypography>
                                                 <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one lowercase')}</MDTypography>
                                                 <MDTypography variant={'caption'}>{t('ForgotPasswordPage.Have at least one number')}</MDTypography>
                                             </FormControl>
                                         </MDBox>
                                         <MDBox mb={2}>
                                             <FormControl
                                                 error={!!errors.confirmPassword}
                                                 fullWidth
                                                 required
                                             >
                                                 <MDInput
                                                     type={showPasswordConfirmation ? 'text' : 'password'}
                                                     label={t('ForgotPasswordPage.New Password Confirmation')}
                                                     variant="standard"
                                                     fullWidth
                                                     required
                                                     {...register("confirmPassword")}
                                                     InputProps={{
                                                         endAdornment:
                                                             <InputAdornment position="end">
                                                                 <IconButton
                                                                     aria-label="toggle password visibility"
                                                                     onClick={handleClickShowPasswordConfirmation}
                                                                     edge="end"
                                                                 >
                                                                     {showPasswordConfirmation ?
                                                                         <VisibilityOff color={darkMode ? 'white' : 'info.main'}/> :
                                                                         <Visibility color={darkMode ? 'white' : 'info.main'}/>}
                                                                 </IconButton>
                                                             </InputAdornment>

                                                     }}
                                                 />
                                                 <FormHelperText
                                                     sx={{fontWeight: 'medium'}}>{errors?.confirmPassword?.message}</FormHelperText>
                                             </FormControl>
                                         </MDBox>

                                     </MDBox>
                                 </MDBox>
                             </div>
                            <MDBox mt={2} sx={{display: "flex", justifyContent: "space-around"}}>
                                <MDButton variant="outlined" color="info" onClick={() => {

                                    setOpen(false)
                                }}>
                                    {t('Cancel')}
                                </MDButton>
                                <MDButton variant="gradient" color="info"
                                    onClick={onSubmit}
                                >
                                    {t('Submit')}
                                </MDButton>
                            </MDBox>
                        </FramerFade>

                    </div>
                </MDBox>
            </MDBox>
            {/*</CoverLayout>*/}
        </React.Fragment>
    )
}
export default UserPasswordChange